import React, {Component} from 'react';

import _ from "lodash";
import InputMask from 'react-input-mask';

import Datepicker from "../../../../components/Datepicker/datepicker";
import PlateInput from "../../../../components/PlateInput/plateInput";
import formatter from "../../../../utils/formatters";

export default class ProviderForm extends Component {

    componentDidMount(){
        window.initializeCollapsible();
        window.initializeSelects('body');
        window.bindSelectAction(this.productSelect, this.props.handleSelect);
        window.bindSelectAction(this.terminalSelect, this.props.handleSelect);
        window.bindSelectAction(this.providerSelect, this.props.handleSelect);
    }

    render() {

        let provider_name = '';
        if(this.props.state.providers){
            let provider = this.props.state.providers.find(p => p.id === this.props.state.provider);
            if(provider)provider_name = provider.business_name;
        }

        let loadVolumeLabel = 'Cantidad cargada';
        if(this.props.state.product && this.props.state.products){
            let product = this.props.state.products.find(p => p.id === parseInt(this.props.state.product, 10));
            if(product){
                loadVolumeLabel = `${_.capitalize(product.origin_unit_of_measure)}. cargados ${product.origin_density ? ` a ${formatter.floatFormat(product.origin_density)}º` : ""}`;
            }
        }
        return (
            <div className={"row no-padding thin-row trip-form"}>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Información Orden</h4>
                    </div>
                    <div className={"row margin-top-10"}>
                        <div className={"col s6 input-field disabled"}>
                            <label className="active">Proveedor</label>
                            <p className={"field-p truncate"}>{provider_name}</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Producto</label>
                            <select defaultValue={this.props.state.product}
                                    data-state-var="product"  ref={ref => {this.productSelect = ref}}>
                                <option value="">Seleccione producto</option>
                                {this.props.state.products && this.props.state.products.map(product => {
                                    return <option key={product.id} id={product.id}
                                                   value={product.id}>{product.name}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Tipo de viaje</label>
                            <p className={"field-p"}>Viaje CIF</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Destino</label>
                            <select defaultValue={this.props.state.terminal}
                                    data-state-var="terminal"  ref={ref => {this.terminalSelect = ref}}>
                                <option value="">Seleccione destino</option>
                                {this.props.state.terminals && this.props.state.terminals.map(terminal => {
                                    return <option key={terminal.id} id={terminal.id}
                                                   value={terminal.id}>{terminal.name}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className={"row thin-row"}>
                        <div className={"col s6 input-field "}>
                            <label className="active">Fecha de Carga</label>
                            <Datepicker classname="input-grey" placeholder={"Ingrese fecha"}
                                        value={this.props.state.load_datetime} format={"YYYY-MM-DDTh:mm"}
                                        id="load_datetime" action={this.props.handleDate} />
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">{loadVolumeLabel}</label>
                            <input placeholder={"Ingrese cantidad"} value={this.props.state.provider_load_volume}
                                   onChange={(ev) => this.props.handleInput('provider_load_volume', ev.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Información Transporte</h4>
                    </div>
                    <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Empresa Transportista</label>
                                <input placeholder={"Ingrese empresa"} value={this.props.state.carrier}
                                       onChange={(ev) => this.props.handleInput('carrier', ev.target.value)}
                                />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Nro. Remito</label>
                                <InputMask placeholder={"Ingrese nro remito"} value={this.props.state.provider_trip_receipt}
                                           mask={'9999-99999999'}
                                           onChange={(ev) => this.props.handleInput('provider_trip_receipt', ev.target.value)}
                                />
                            </div>
                        </div>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Chofer - Nombre y Apellido</label>
                                <input placeholder={"Ingrese nombre del chofer"} value={this.props.state.driver_name}
                                       onChange={(ev) => this.props.handleInput('driver_name', ev.target.value)}
                                />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Licencia de Conducir</label>
                                <input placeholder={"Ingrese licencia"} value={this.props.state.driver_doc}
                                       onChange={(ev) => this.props.handleInput('driver_doc', ev.target.value)}/>
                            </div>
                        </div>
                        <div className={"row thin-row"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Patente Chasis</label>
                                <PlateInput
                                    placeholder="Ingrese patente del chasis" value={this.props.state.truck_plate}
                                    action={this.props.handleInput} name={'truck_plate'}
                                />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Patente Acoplado</label>
                                <PlateInput
                                    placeholder="Ingrese patente del acoplado" value={this.props.state.trailer_plate}
                                    action={this.props.handleInput} name={'trailer_plate'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"col s12 input-field input-grey"}>
                    <label className="active">Observaciones</label>
                    <input placeholder={"Ingrese las observaciones del viaje"} value={this.props.state.provider_observations}
                           onChange={(ev) => this.props.handleInput('provider_observations', ev.target.value)}/>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/newTrip/ProviderForm.js